import React from "react";

export default function RouteRow({ 
  name, 
  isVisible, 
  onToggle, 
  onDelete, 
  countInfo,
  isExpanded,      
  onExpandToggle,  
  hasChildren,
  showToggle = true,
  textSize = 13 ,
  lengthSize =  10    
}) {
  return (
    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 0', borderBottom:'1px dashed #E5E7EB'}}>
      
      {/* Área Izquierda: Flecha y Nombre */}
      <div 
        style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: hasChildren ? 'pointer' : 'default' }} 
        onClick={hasChildren ? onExpandToggle : undefined}
      >
        {hasChildren && (
            <span style={{ fontSize: '10px', color: '#9CA3AF', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>▼</span>
        )}
        <span style={{
            fontSize: textSize, fontWeight:500, 
            color: isVisible ? '#374151' : '#9CA3AF',
            textDecoration: (!isVisible && countInfo) ? 'line-through' : 'none',
            transition: 'color 0.2s'
        }}>
          {name}
          {countInfo > 0 && <span style={{fontSize: lengthSize, marginLeft:'6px', color:'#9CA3AF'}}>({countInfo})</span>}
        </span>
      </div>
      
      {/* Área Derecha: Controles */}
      <div style={{display: 'flex', gap: '12px', alignItems: 'center'}}>
        {onDelete && (
            <div onClick={onDelete} style={styles.deleteBtn} title="Eliminar Ruta">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
            </div>
        )}
        
        
        {showToggle && <ToggleSwitch isOn={isVisible} onToggle={onToggle} />}
      </div>
    </div>
  );
}

// Switch "visible en el mapa". Es un <button role="switch"> para que se pueda usar con teclado y
// lectores de pantalla; `isBusy` lo bloquea y pinta un spinner en la perilla.
export function ToggleSwitch({ isOn, onToggle, isBusy = false, label }) {
  return (
    <button
        type="button"
        role="switch"
        aria-checked={isOn}
        aria-label={label}
        aria-busy={isBusy || undefined}
        onClick={(e) => { e.stopPropagation(); if (!isBusy && onToggle) onToggle(); }}
        style={{
            width:36, height:20, borderRadius:20, position:'relative', flexShrink: 0, border: 'none', padding: 0,
            cursor: isBusy ? 'wait' : 'pointer',
            backgroundColor: isOn ? '#10B981' : '#D1D5DB',
            transition:'background-color 0.2s'
        }}
    >
        <span style={{
            width:16, height:16, borderRadius:'50%', backgroundColor:'white',
            position:'absolute', top:2, left:2,
            transform: isOn ? 'translateX(16px)' : 'none',
            transition:'transform 0.2s ease',
            boxShadow:'0 1px 2px rgba(0,0,0,0.2)',
            display:'grid', placeItems:'center'
        }}>
            {isBusy && (
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true" style={{ animation: 'mon-spin 0.8s linear infinite' }}>
                    <circle cx="12" cy="12" r="9" stroke="#D1D5DB" strokeWidth="4" />
                    <path d="M12 3a9 9 0 0 1 9 9" stroke="#10B981" strokeWidth="4" strokeLinecap="round" />
                </svg>
            )}
        </span>
    </button>
  );
}

const styles = {
  deleteBtn: { width: 26, height: 26, borderRadius: '6px', backgroundColor: '#FFF1F2', border: '1px solid #FECDD3', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#E11D48', transition: 'all 0.2s ease' }
};